import { Temporal } from '@imago/api-client'
import { type HTML } from './_HTML.ts'

export const GAHTOnboarding_ID = 'imago.gaht.onboarding' as ProductID

const ServiceID__Brand: unique symbol = Symbol()
export type ServiceID = string & {[ServiceID__Brand]: never}

const ProductID__Brand: unique symbol = Symbol()
export type ProductID = string & {[ProductID__Brand]: never}

export type ServiceProductID = ServiceID & ProductID

export interface ServiceInfo {
	ID: ServiceID
	title: string
	duration: Temporal.Duration
	freezeTime: Temporal.Duration
}

export interface ProductInfo {
	ID: ProductID
	title: string
	price: string
	description?: HTML
	bio?: HTML
}

export type ServiceProductInfo = ServiceInfo & ProductInfo
export type ServiceOrProductInfo = ServiceInfo | ProductInfo

export function isService(ps: ServiceOrProductInfo): ps is ServiceInfo {
	return (ps as ServiceInfo).duration !== undefined
}

export function isProduct(ps: ServiceOrProductInfo): ps is ProductInfo {
	return (ps as ProductInfo).price !== undefined
}

export function isServiceProduct(ps: ServiceOrProductInfo): ps is ServiceProductInfo {
	return isService(ps) && isProduct(ps)
}
